import React from 'react';
import './RiddleButton.css';

const RiddleButton = ({ onOpen, disabled, isOpen }) => {
  return (
    <div className="riddle-button-wrap">
      <button
        className={`riddle-button ${disabled ? 'disabled' : ''} ${isOpen ? 'active' : ''}`}
        onClick={onOpen}
        disabled={disabled}
        type="button"
      >
        <span className="label">Riddle</span>
        
      </button>
    </div>
  );
};

export default RiddleButton;
